import React, { useState, useContext, useEffect } from "react";
import styles from "./Walkthrough.module.css";
import Tour from "reactour";
import { useMediaQuery } from "react-responsive";
import MediaQuery from "react-responsive";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import VideoContext from "../../store/video-context";
import PrimaryAdBanner from "../PrimaryAdBanner/PrimaryAdBanner.lazy";
import { isEmpty, groupBy } from "lodash";

const Walkthrough = () => {
  const vContext = useContext(VideoContext);
  const [isAdmin, setIsAdmin] = useState(vContext.isAdmin);

  const change_login_flag = () => {
    console.log("yes-here");

    let data: { [index: string]: any } = { command: "savePlayerLogin" };

    data.userID = vContext.userData.user_id;
    //data.player_login = "1";

    fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        result.json();
        console.log("yes-check", result.json());
      })
      .catch((error) => {
        console.log("player_login_change_error", error);
      });
  };

  const [isTourOpen, setIsTourOpen] = useState(true);

  const disableBody = (target: any) => disableBodyScroll(target);
  const enableBody = (target: any) => {
    enableBodyScroll(target);
    change_login_flag();
  };

  const desktop_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const desktop_steps_wo_instru = [
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const desktop_steps_wo_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];
  const desktop_steps_wo_steps_and_surg = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const desktop_steps_wo_left = [
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a Rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const desktop_steps_wo_surgery_details = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".right-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const desktop_steps_wo_enquire = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];
  const desktop_steps_wo_enquire_and_left = [
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];
  const desktop_steps_wo_enquire_and_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".conversation-section",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching? 
          Leave a rating or Share with your
          friends
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const mobile_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),

      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];
  const mobile_steps_wo_instru = [
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];
  const mobile_steps_wo_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const mobile_steps_wo_surgery_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".card:nth-child(2)",
      content: (
        <div>
          {" "}
          Steps are tagged to video position. Click on timestamp if you wish to
          watch a particular step of the surgery
          
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },

    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const mobile_steps_wo_steps_and_surgery_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },

    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const mobile_steps_wo_instru_and_surgery_steps = [
    {
      selector: ".card:nth-child(1)",
      content: (
        <div>
          {" "}
          Instruments used in surgery are listed here. If you notice time stamp,
          click on that to see how a particular instrument is used in surgery.
          Click on Call icon, if you are interested in buying it.
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "1em",
        height: "auto",
        maxWidth: "30em",
        textalign: "justify",
      },
    },
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const mobile_steps_wo_top = [
    {
      selector: ".chat-open-btn",
      content: (
        <div>
          {" "}
          Post your questions in the chat box and get your queries answered
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".center-ad",
      content: (
        <div>
          {" "}
          Click enquire if you are interested in knowing more details about
          products listed here
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".surgery-details-section",
      content: (
        <div>
          {" "}
          Check the Surgery Literature here like Pre-op/Post-Op measures, Steps
          of the surgery, Port positions and more!
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Skip
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        textalign: "justify",
      },
    },
    {
      selector: ".step-6",
      content: (
        <div>
          {" "}
          Like what you are are watching?  Leave a rating or Share with
          your friends
          
          <div style={{ textAlign: "right" }}>
            <button
              className="btn btn-primary"
              id="skip-btn"
              onClick={() => setIsTourOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      ),
      style: {
        borderRadius: "6px",
        paddingTop: "2.5em",
        textalign: "justify",
      },
    },
  ];

  const [enquire, setEnquire] = useState(false);

  const check_enquire = document.querySelector(".right-ad");
  //const check_steps = vContext.tagData.steps;
  const check_steps = vContext.accordionData;
  const check_instru = vContext.tagData.instruments;
  const check_surgery_section = document.querySelector(
    ".surgery-details-section"
  );

  //console.log("yes", vContext.detailsRef);
  console.log("yes", check_steps.length);
  function check() {
    //steps and instrument not present , enquire and surgery-steps present

    if (
      check_instru.length == 0 &&
      check_steps.length == 0 &&
      check_enquire != null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_left}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instrument not present , steps, enquire and surgery-steps present

    if (
      check_instru.length == 0 &&
      check_steps.length != 0 &&
      check_enquire != null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_instru}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //steps not present , instruments, enquire and surgery-steps present

    if (
      check_instru.length == 0 &&
      check_steps.length == 0 &&
      check_enquire == null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_enquire_and_left}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instruments, enquire and surgery-steps present , steps not present,

    if (
      check_instru.length != 0 &&
      check_steps.length == 0 &&
      check_enquire != null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instrument and surgery-steps present , steps and enquire not present

    if (
      check_instru.length != 0 &&
      check_steps.length == 0 &&
      check_enquire == null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_enquire_and_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instrument and enquire present , steps and surgery-steps not present

    if (
      check_instru.length != 0 &&
      check_steps.length == 0 &&
      check_enquire != null &&
      check_surgery_section == null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_steps_and_surg}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instrument, steps and surgery-steps present , enquire not present

    if (
      check_instru.length != 0 &&
      check_steps.length != 0 &&
      check_enquire == null &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_enquire}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instrument, steps and enquire present , surgery-steps not present

    if (
      check_instru.length != 0 &&
      check_steps.length != 0 &&
      check_enquire != null &&
      check_surgery_section == null
    ) {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps_wo_surgery_details}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //all present
    else {
      return (
        <MediaQuery minWidth={768}>
          <Tour
            steps={desktop_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }
  }

  function mobile_check() {
    // instruments and steps not present, surgery-details present
    if (
      check_instru.length == 0 &&
      check_steps.length == 0 &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_top}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instruments and surgery-steps present, steps not present

    if (
      check_instru.length != 0 &&
      check_steps.length == 0 &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //instruments present, steps and surgery-steps not present

    if (
      check_instru.length != 0 &&
      check_steps.length == 0 &&
      check_surgery_section == null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_steps_and_surgery_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //steps  present, instruments and surgery-steps not present

    if (
      check_instru.length == 0 &&
      check_steps.length != 0 &&
      check_surgery_section == null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_instru_and_surgery_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //steps and surgery-steps present, instruments not present

    if (
      check_instru.length == 0 &&
      check_steps.length != 0 &&
      check_surgery_section != null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_instru}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    // instruments and steps present, surgery-details not present
    if (
      check_instru.length != 0 &&
      check_steps.length != 0 &&
      check_surgery_section == null
    ) {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps_wo_surgery_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }

    //all present
    else {
      return (
        <MediaQuery minWidth={320} maxWidth={767}>
          <Tour
            steps={mobile_steps}
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
            onAfterOpen={disableBody}
            onBeforeClose={enableBody}
            showCloseButton={false}
          />
        </MediaQuery>
      );
    }
  }

  return (

    <>

     { vContext.videoData.player_login == 0 &&
     <>
      <MediaQuery minWidth={768}>{check}</MediaQuery>
      <MediaQuery minWidth={320} maxWidth={767}>
        {mobile_check}
      </MediaQuery>
     </>
     }
    </>

  );
};

export default Walkthrough;
